import { render, staticRenderFns } from "./CharacterDeckMiniPanel.vue?vue&type=template&id=771e682a&"
import script from "./CharacterDeckMiniPanel.vue?vue&type=script&lang=js&"
export * from "./CharacterDeckMiniPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports